import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

@Injectable()
export class FirebaseAuthService implements CanActivate {

  usuario: firebase.User;

  constructor(private firebaseAuth: AngularFireAuth, private router: Router) {
    firebaseAuth.authState.subscribe(u => {
      this.usuario = u;
    });
  }

  canActivate(): Observable<boolean> {
    return this.firebaseAuth.authState
      .take(1)
      .map(authState => !!authState)
      .do(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/admin']);
        }
      });
  }

  signup(email: string, password: string) {
    this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password)
      .then(value => {
      })
      .catch(err => {
      });
  }

  login(email: string, password: string) {
    this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(email, password)
      .then(value => {
      })
      .catch(err => {
      });
  }

  logout() {
    this.firebaseAuth
      .auth
      .signOut();
    this.router.navigate(['/admin']);
  }

}



// WEBPACK FOOTER //
// ./src/app/_guard/firebase-auth-service.ts